export default {
  configure: 'Configura',
  chat: 'Chat',
  transferToAgent: 'Transferir a un agente',
  clickToHelpPerson: 'Esta persona necesita ayuda, haz click para ayudarla',
  openConversation: 'Abrir conversación',
  conversations: 'Conversaciones',
  noPendingConversations: 'No hay conversaciones pendientes',
  lastMessage: 'Último mensaje',
  channel: 'Canal',
  yourConversations: 'Tus conversaciones',
  closedConversations: 'Conversaciones cerradas',
  allConversations: 'Todas las conversaciones',
  finishConversation: 'Finalizar conversación',
  closeChat: 'Cerrar chat',
  loadingMessages: 'Cargando mensajes',
  noMessagesFound: 'No hay ningún mensaje',
  conversationAlreadyTaken: 'La conversación ya fue tomada',
  toWrite: 'Escribir',
  toHelp: 'Ayudar',
  attendConversation: 'Atender esta conversación',
  quickResponses: 'Respuestas rápida',
  writeMessage: 'Escribir mensaje',
  conversationFinishedByAdvisor: 'Conversación finalizada por el asesor',
  finishedConversation: 'Conversación finalizada',
  conversationTakenByAdvisor: 'Conversación tomada por el asesor',
  updatedConversation: 'Conversación actualizada',
  configureChat: 'Configurar chat',
  loadingConversations: 'Cargando conversaciones',
  waitingForAdvisor: 'En espera de asesor',
  finished: 'Finalizada',
  takenByMe: 'Tomada por mi',
  takenByAdvisor: 'Tomada por {advisor}',
  withAdvisor: 'Con asesor',
  registered: 'La persona aún no ha escrito',
  canIHelpYouWithSomething: '¿Puedo ayudarte en algo?',
  attachInWebSite: 'Adjuntar en sitio web',
  authenticationType: 'Tipo de autenticación',
  twoFactorAuthentication: 'Autenticación de dos factores',
  noAuthentication: 'Sin autenticación',
  externalAuthentication: 'Autenticación externa',
  form: 'Formulario',
  city: 'Ciudad',
  onDemand: 'A solicitud',
  onStartup: 'Al comienzo',
  appearance: 'Apariencia',
  light: 'Claro',
  dark: 'Oscuro',
  mainColor: 'Color principal',
  pickAMainColor: 'Selecciona un color principal',
  reestablishColor: 'Reestablecer color',
  backgroundColor: 'Color de fondo',
  pickABackgroundColor: 'Selecciona un color de fondo',
  customLogo: 'Logo personalizado',
  customTitle: 'Titulo personalizado',
  customBubbleMessage: 'Mensaje de burbuja personalizado',
  showEmojis: 'Mostrar emojis',
  customQuestions: 'Preguntas personalizadas',
  insertChatQuestions: 'Ingresa las preguntas que deseas que aparezcan en el chat',
  permanentMessages: 'Mensajes permanentes',
  insertFirstChatMessages: 'Ingresa los mensajes que deseas que aparezcan como primer mensaje del chat',
  reasonsOfFinishedConversation: 'Motivos de finalización de conversación',
  possibleReasonsAdvisorEndConversation: 'Ingresa los posibles motivos por los que un asesor puede finalizar una conversación',
  insertQuickResponsesForAdvisors: 'Ingresa las respuestas rápidas que tendrán disponibles los asesores',
  inactivityMessage: 'Mensaje de inactividad',
  enableInactivityMessage: 'Habilitar mensaje de inactividad',
  insertInactivityMessage: 'Ingresa el mensaje de inactividad',
  timeForTriggeringInactivityMessage: 'Tiempo en segundos para disparar mensaje de inactividad',
  attentionSchedule: 'Horarios de atención',
  outOfServiceMessage: 'Mensaje de fuera de servicio',
  customFormMessage: 'Mensaje personalizado en el formulario',
  nonWorkingDay: 'No laborable',
  allDay: 'Todo el día',
  noOpening: 'Sin apertura',
  noClosing: 'Sin cierre',
  advisors: 'Asesores',
  assignConversationsAutomaticallyToConnectedAdvisors: 'Asignar conversaciones automáticamente a asesores conectados',
  pickAdvisors: 'Seleccionar asesores',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  configurationSavedSuccessfully: 'Configuración guardada correctamente',
  insertChatInYourWebSite: 'Insertar chat en tu sitio web',
  instructionsForInsertingChat: 'Para agregar el chat en tu sitio web, debes agregar el siguiente Script en el Footer de tu sitio',
  copiedScript: 'Script copiado',
  errorCopyingScript: 'Error al copiar el script',
  noMessage: 'Sin mensaje',
  toTransfer: 'Transferir',
  agentSuccessfullyTransferred: 'Agente transferido correctamente',
  youAreDeclaringNoWorkingDay: 'Estas declarando este día como no laborable',
  opening: 'Apertura',
  closing: 'Cierre',
  establishAgentsForSelfAllocationOfConversations: 'Establecer agentes para la autoasignación de conversaciones',
  assignConversations: 'Asignar Conversaciones',
  ready: 'Listo',
  advisorUpdated: 'Asesor actualizado',
  errorPrecessingRequest: 'Sucedió un error al procesar la petición',
  periodStatistics: 'Estadísticas del período',
  noStatsFoundForThisDateRange: 'No se encontraron estadístias para este rango de fechas',
  forEachDayHowMuchWasTheAverageTimePerConversation: 'Por cada día, ¿Cuánto fue el promedio de tiempo por conversación?',
  forEachAdvisorHowMuchWasTheAverageTimePerConversation: 'Por cada asesor, ¿Cuánto fue el promedio de tiempo por conversación?',
  statsPerDay: 'Estadísticas por día',
  noStatsFoundForThisDay: 'No se encontraron estadísticas para este día',
  usersCreated: 'Usuarios creados',
  attendedConversations: 'Conversaciones Atendidas',
  noAttendedConversations: 'Conversaciones no Atendidas',
  attendedAndUnansweredConversations: 'Conversaciones atendidas y no atendidas',
  attended: 'Atendidas',
  averageTimeBeforeTheAdvisorTookControl: 'Tiempo promedio antes de que el asesor tomara el control',
  averageTimeSinceTheAdvisorTookControl: 'Tiempo promedio desde que el asesor toma el control',
  howManyWereAttended: '¿Cuantas fueron atendidas?',
  conversationsNumber: 'Número de conversaciones',
  howManyConversationsDidEachAdvisorAttended: '¿Cuántas conversaciones atendió cada asesor?',
  numberConversationsAttended: 'Número de conversaciones atendidas',
  howManyUsersWereCreated: '¿Cuántos usuarios se crearon?',
  users: 'Usuarios',
  howLongWasTheAverageTimePerConversation: '¿Cuánto fue el promedio de tiempo por conversación?',
  minutes: 'Minutos',
  whatWereTheTopicsOfTheConversations: 'Cuáles fueron los temas de las conversaciones',
  numberOfRepetitions: 'Número de repeticiones',
  howManyConversationsWereAttendedForEachHour: '¿Cuántas conversaciones se atendieron por cada hora?',
  howManyConversationsDidEachAdvisorHavePerHour: '¿Cuántas conversaciones atendió cada asesor por hora?',
  howManyUsersWereCreatedPerHour: '¿Cuántos usuarios se crearon por hora?',
  advisor: 'Asesor',
  tellUsWhoYouAre: 'Indicanos quién eres',
  selectTheInformationYouWantToAskPeople: ' Selecciona la información que deseas pedirle a las personas',
  startConversation: 'Iniciar conversación',
  emptyMessage: 'Mensaje vacío',
  blockMessageComposer: 'Bloquear compositor de mensaje',
  timeZone: 'Zona horaria',
  addSchedule: 'Agregar Horario',
  checkTheServiceHours: 'Verifica los horarios de atención',
  newKeybeConversation: 'Nueva conversación en Keybe',
  details: 'Detalles',
  enterName: 'Ingresa un nombre',
  enterEmail: 'Ingresa un correo electrónico',
  enterPhone: 'Ingresa un teléfono',
  enterCountry: 'Ingresa el país',
  country: 'País',
  enter: 'Ingresa',
  enterValue: 'Ingresa el valor',
  selectPerson: 'Seleccione una persona',
  anonymousPerson: 'Esta persona es anónima',
  personDetails: 'Detalles de la persona',
  newApplication: 'Nueva aplicación',
  channels: 'Canales',
  authentication: 'Autenticación',
  finalization: 'Finalización',
  customizeYourConversation: 'Personaliza tu conversación',
  schedules: 'Horarios',
  assignment: 'Asignación',
  correctlyEmailConnection: 'Se ha conectado tu correo correctamente',
  correctlyEmailDisconnection: 'Se ha desconectado tu correo correctamente',
  administratorsOnly: 'Solo administradores',
  setTheEndTimeForConversations: 'Configura el tiempo de finalización de las conversaciones',
  automaticallyEndUnansweredConversations: 'Finalizar automáticamente conversaciones que han dejado de ser respondidas',
  definesTheTimeUserStopsResponding: 'Define el tiempo para finalizar la conversación una vez el usuario deje de responder',
  finishAfter: 'Finalizar después de',
  enterTheReasonForAutomaticCompletion: 'Ingresa la razón de finalización automática',
  position: 'Posición',
  defaultLanguage: 'Idioma por defecto',
  tagsAsAMethodOfAutoAssignment: 'Tags como método de auto-asignación',
  enterTags: 'Ingresa Tags',
  updateTags: 'Actualizar Tags',
  communicationChannels: 'Canales de comunicación',
  youMustPreviouslyGrantKeybeGooglePermission: 'Debes conceder permisos previamente a Keybe para acceder a tu cuenta de Google',
  connectWithGoogle: 'Conectar con Google',
  youHaveCurrentlyAuthorizedKeybe: 'Actualmente has autorizado a Keybe para acceder a tu cuenta',
  andYouHaveCorrectlyConfiguredGmail: 'y has configurado correctamente Gmail',
  disconnectFromGmail: 'Desconectar de gmail',
  connectToGmail: 'Conectar a gmail',
  confirmationTimeout: 'Tiempo de espera de confirmación',
  serverUrl: 'Url del servidor',
  pickATimeGreaterOrEqualThan15Minutes: 'Elige un tiempo mayor o igual a 15 minutos',
  conversationWithAdviser: 'Conversación con un asesor',
  conversationWithAI: 'Conversación con AI',
  notificationPermissions: 'Rechazaste los permisos para mostrar notificaciones. Consulta la información del sitio en la barra de direcciones web y permite las notificaciones para continuar recibiendo alertas cuando recibas un mensaje',
  dontShowMessage: 'No mostrar más este mensaje'
}
